import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { ExportCSV } from './ExportCSV';
import { ColumnConfig } from '../../../DataTable/types';
import { buildExportData } from '../../../../../components/ExportButtons/ExportPrintButtons';

interface Props {
  title: string;
  exportFileName: string;
  columns: ColumnConfig[];
  allData: any[];
  selectedColumns: string[];
  enableButtons: boolean;
  translation: any;
  reportNameInEn: string;
}

export const ReportTitle: FC<Props> = ({ title, exportFileName, columns, allData, selectedColumns, enableButtons, reportNameInEn }) => {
  const classes = useStyles();

  const exportTableData = buildExportData(allData, columns, selectedColumns);
  const reportColumns = (selectedColumns.length === 0 ? columns : columns.filter((col) => selectedColumns.includes(col.label))).map((col) => col.label);

  return (
    <Grid container direction="row" justify="space-between" alignContent="flex-start" alignItems="center" className={classes.root}>
      <Grid item xs={11}>
        <Typography className={classes.title}>{title}</Typography>
      </Grid>
      <Grid item xs={1}>
        <ExportCSV exportFileName={exportFileName} columns={reportColumns} exportTableData={exportTableData} isEnabled={enableButtons} reportNameInEn={reportNameInEn} />
      </Grid>
    </Grid>
  );
};
